import React from 'react';
import clsx from 'clsx';

import SideBar from '../../partials/SideBar';
// import HeaderLogin from '../../partials/Header/HeaderLogin';
import ContentLoader from '../../../ContentLoader';
import MainHeader from './MainHeader';
import useStyles from './index.style';
import Footer from '../../partials/Footer';
import { HEADER_TYPE } from '../../../../constants/ThemeOptions';

// import Header from '../../partials/Header';
import defaultContext from '../../../contextProvider/AppContextProvider/defaultContext';

import CmtHeaderMain from '../../../../../@coremat/CmtLayouts/Horizontal/Header/HeaderMain';
import CmtHeader from '../../../../../@coremat/CmtLayouts/Horizontal/Header';
import CmtHorizontalLayout from '../../../../../@coremat/CmtLayouts/Horizontal';
import HCmtSidebar from '../../../../../@coremat/CmtLayouts/Horizontal/Sidebar';
import HCmtContent from '../../../../../@coremat/CmtLayouts/Horizontal/Content';
import HCmtFooter from '../../../../../@coremat/CmtLayouts/Horizontal/Footer';

const horizontalLayoutOptions = {
  showFooter: true,
  headerType: HEADER_TYPE.STATIC,
  layoutStyle: defaultContext.layoutType,
};

const ResponsiveLayout = ({ className, children }) => {
  const classes = useStyles();

  return (
    <CmtHorizontalLayout
      layoutOptions={horizontalLayoutOptions}
      className={clsx('Cmt-horizontalMinimalLayout', className)}
      header={
        <CmtHeader className={classes.appHeaderDark}>
          <CmtHeaderMain>
            <MainHeader />
          </CmtHeaderMain>
        </CmtHeader>
      }
      /*footer={
        <HCmtFooter type="static">
          <Footer />
        </HCmtFooter>
      }*/
      sidebar={
        <HCmtSidebar>
          <SideBar />
        </HCmtSidebar>
      }>
      <HCmtContent>
        {children}
        <ContentLoader />
      </HCmtContent>
    </CmtHorizontalLayout>
  );
};

export default ResponsiveLayout;
